import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import { GraphQLHelper } from 'src/app/shared/lib/helpers/graphql.helper';
import {
  buildGetAllSourcingProviderQuery,
  buildGetAllSourcingWithProjectionQuery,
  DEFAULT_SOURCING_PROVIDER_FIELDS,
  queryGetAllProviderSourcing,
  queryGetProviderSourcingById,
  queryGetProviderSourcingByName,
} from '../graphql/proveedores.queries';

@Injectable({ providedIn: 'root' })
export class ProveedoresSourcingService {
  constructor(
    private graphService: GraphService,
    private graphQLHelper: GraphQLHelper,
  ) {}

  private buildFields(projectionExpression: string | undefined): string {
    const selectedFields = projectionExpression
      ? projectionExpression
          .split(',')
          .map((f) => f.trim())
          .filter(Boolean)
      : DEFAULT_SOURCING_PROVIDER_FIELDS;

    return this.graphQLHelper.buildGraphQLFields(selectedFields);
  }

  // TODO: Revisar para cambiar luego, se tiene que mapear porque en sales-api existe y si mejor lo movemos a sourcing-api
  getAllWithProjectionBySales(projectionExpression?: string, includeDisabled?: boolean): Observable<any[]> {
    const fields = this.buildFields(projectionExpression);
    const query = buildGetAllSourcingWithProjectionQuery(fields);

    return this.graphService
      .queryGraphQLSales<{ getAllProvidersWithProjectionExpression: any[] }>({
        query,
        variables: { projectionExpression, includeDisabled: includeDisabled ?? false },
      })
      .pipe(
        map((response) => response.getAllProvidersWithProjectionExpression || []),
        catchError((error) => {
          console.error('Error fetching proveedores sourcing by sales:', error);
          return throwError(() => new Error('Error al obtener proveedores desde sales'));
        }),
      );
  }

  getAllWithProjection(projectionExpression?: string): Observable<any[]> {
    const fields = this.buildFields(projectionExpression);
    const query = buildGetAllSourcingProviderQuery(fields);

    return this.graphService
      .queryGraphQLSourcing<{ getAllProvider: any[] }>({
        query,
        variables: {},
      })
      .pipe(
        map((response) => response.getAllProvider || []),
        catchError((error) => {
          console.error('Error fetching proveedores sourcing:', error);
          return throwError(() => new Error('Error al obtener proveedores'));
        }),
      );
  }

  getAll(): Observable<any[]> {
    return this.graphService
      .queryGraphQLSourcing<{ getAllProvider: any[] }>({
        query: queryGetAllProviderSourcing,
        variables: {},
      })
      .pipe(
        map((response) => response.getAllProvider || []),
        catchError((error) => {
          console.error('Error fetching proveedores sourcing:', error);
          return throwError(() => new Error('Error al obtener proveedores'));
        }),
      );
  }

  getById(id: String): Observable<any> {
    return this.graphService
      .queryGraphQLSourcing<any>({
        query: queryGetProviderSourcingById,
        variables: { id },
      })
      .pipe(
        map((response) => response.getProvider || null),
        catchError((error) => {
          console.error('Error fetching proveedor sourcing by ID:', error);
          return throwError(() => new Error('Error al obtener proveedor'));
        }),
      );
  }

  getByName(name: String): Observable<any> {
    return this.graphService
      .queryGraphQLSourcing<any>({
        query: queryGetProviderSourcingByName,
        variables: { name },
      })
      .pipe(
        map((response) => response.getProviderByName || null),
        catchError((error) => {
          console.error('Error fetching proveedor sourcing by name:', error);
          return throwError(() => new Error('Error al obtener proveedor'));
        }),
      );
  }
}
